import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { CampaignContext } from '../../../../contexts/CampaignContext'
import { ReadOnlyContext } from '../../../../contexts/ReadOnlyContext'

export default observer(function ArchivedReadOnlyProvider({ children }) {
  const { isArchived } = useContext(CampaignContext)

  return <ReadOnlyContext.Provider value={isArchived}>{children}</ReadOnlyContext.Provider>
})
